import {BookingStatusDTO} from '@tj/tj-dmp-lib-api';
import {SelectItem} from 'primeng/api';

export interface InvoiceCommandStatusItem extends SelectItem { definition?: string; unavailable?: boolean; }

export function invoiceCommandStatusItems(rows: BookingStatusDTO[], product: string, selected: string[], saved: string[],
    translate: (key: string, params?: object) => string, locale: string): InvoiceCommandStatusItem[] {
    const retained = [...saved, ...selected];
    const items = rows.filter(row => row.productType === product && (row.active
        || retained.some(code => code.toUpperCase() === row.bookingStatus.toUpperCase())))
        .map(row => ({value: retained.find(code => code.toUpperCase() === row.bookingStatus.toUpperCase()) || row.bookingStatus,
            label: row.active ? `${row.label} (${row.bookingStatus})` : translate('callInvoiceConfiguration.disabledStatus', {label: row.label, code: row.bookingStatus}),
            definition: row.definition, unavailable: !row.active}));
    for (const code of retained) {
        if (!items.some(item => item.value.toUpperCase() === code.toUpperCase())) {
            items.push({value: code, label: translate('callInvoiceConfiguration.missingStatus', {code}), definition: '', unavailable: true});
        }
    }
    return items.sort((a, b) => a.label.localeCompare(b.label, locale));
}
